export default "__VITE_ASSET__d4034777__"